import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { setBrandingSelected, setSaveInProgress } from '../store/brandingSlice';
import {
  getProductsSettings,
  getSettingByProduct,
} from '@sonifi/wb-products/services/products.service';
import {
  deleteFile,
  processFiles,
  uploadFiles,
} from '@sonifi/wb-widget/services/file/file.service';
import { PRODUCTS_KEYS } from '@sonifi/wb-products/constants/wbProductsConstants';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';
import { MEDIA_KEYS } from '@sonifi/wb-media/constants/WbMediaConstants';

export const getBrandingBackgroundImage =
  ({ groupId, productsSettings }) =>
  (dispatch) => {
    const productSettingBranding = dispatch(
      getSettingByProduct({ groupId, productKey: PRODUCTS_KEYS.BRANDING }),
    );
    const background =
      productsSettings._embedded[productSettingBranding.background] || null;
    return background;
  };

export const initBranding = (groupId) => async (dispatch) => {
  const productsSettings = await dispatch(getProductsSettings(groupId));
  const productSettingBranding = dispatch(
    getSettingByProduct({ groupId, productKey: PRODUCTS_KEYS.BRANDING }),
  );
  const background = dispatch(
    getBrandingBackgroundImage({ groupId, productsSettings }),
  );
  dispatch(setBrandingSelected({ ...productSettingBranding, background }));
};

export const validBrandingFile = (file) => (dispatch) => {
  const filesProcessed = processFiles({
    fileList: [file],
    mimeTypes: MEDIA_KEYS.MIME.IMAGES,
  });
  if (filesProcessed.rejected.length) {
    dispatch(
      setAlert({
        content:
          'There was an error processing this file. Please select a different file.',
        type: 'warning',
        show: true,
        dismissable: true,
      }),
    );
    return false;
  }
  return true;
};

export const changeBrandingBackground =
  ({ file, brandingSelected, oldBackground }) =>
  async (dispatch) => {
    try {
      dispatch(setSaveInProgress(true));
      let fileRes;
      // Upload File
      if (file) {
        // Delete Old Background File - Don't wait
        oldBackground && deleteFile(brandingSelected.background.id);
        const fRes = await dispatch(
          uploadFiles({
            files: { accepted: [file], rejected: [] },
          }),
        );
        fileRes = fRes.accepted[0]; // Uploading one file
      } else {
        // Delete File
        await deleteFile(brandingSelected.background.id);
      }
      const productSettingBody = {
        background: file ? fileRes.uri : null,
        enabled: true,
        group: brandingSelected.group.uri,
        id: brandingSelected.id,
        product: brandingSelected.product,
        uri: brandingSelected.uri,
      };
      const brandingProductSettingsRes = await apiService.patch(
        `${ENDPOINTS.PRODUCT_SETTINGS}/${productSettingBody.id}`,
        productSettingBody,
      );
      const background = file
        ? brandingProductSettingsRes.data._embedded[
            brandingProductSettingsRes.data.background
          ]
        : null;
      const newBranding = {
        ...brandingProductSettingsRes.data,
        background,
        group: brandingSelected.group,
      };
      dispatch(setBrandingSelected(newBranding));
      dispatch(setSaveInProgress(false));
      dispatch(
        setAlert({
          title: 'Settings saved',
          content:
            'The product settings for this property have been successfully saved.',
          type: 'success',
          show: true,
          dismissable: true,
        }),
      );
      return true;
    } catch (error) {
      dispatch(
        setAlert({
          title: 'Settings save failed',
          content: 'The settings for this property could not be saved.',
          type: 'danger',
          show: true,
          dismissable: true,
        }),
      );
      dispatch(setSaveInProgress(false));
      return false;
    }
  };
